<template>
  <div class="card inventory-lookup">
    <div class="card__header">
      <h2>Backend</h2>
    </div>
    <div class="card__body">
      <el-row :gutter="24">
        <el-col :span="10">
          <div v-if="success === true" class="alert alert-success">
            Sync has successfully started!
          </div>
          <div v-if="message !== ''" class="alert alert-danger">
            {{message}}
          </div>
          <form @submit="formSubmit" ref="startShopifySync">
            <p>Start shopify sync:</p>
            <el-button type="primary" @click="formSubmit">Start</el-button>
          </form>
        </el-col>
      </el-row>
    </div>
    <div class="card__body">
      <el-row :gutter="24">
        <el-col :span="10">
          <div v-if="fulfillmentLatencyNumberSuccess === true" class="alert alert-success">
            Fulfillment latency updated!
          </div>
          <div v-if="fulfillmentLatencyNumberMessage !== ''" class="alert alert-danger">
            {{fulfillmentLatencyNumberMessage}}
          </div>
            <p>Edit fulfillment latency:</p>
            <select id="number-select" v-model="fulfillmentLatencyNumber" @change="postfulfillmentLatency">
              <option v-for="number in numbers" :key="number" :value="number">
                {{ number }}
              </option>
            </select><br>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "../../repositories";
export default {
  data() {
    return {
      success: false,
      message: '',
      fulfillmentLatencyNumberMessage: '',
      fulfillmentLatencyNumberSuccess: '',
      numbers: Array.from({ length: 12 }, (_, i) => i + 1),
      fulfillmentLatencyNumber: 1
    };
  },
  created() {
    this.fetchFulfillmentLatencyNumber();
  },
  methods: {
    async postfulfillmentLatency() {
      axios.post('/admin-settings/update-setting', {
        setting_name: 'fulfillment_latency',
        value: { value: this.fulfillmentLatencyNumber },
      })
      .then(response => {
        if (response.data.success) {
          this.fulfillmentLatencyNumberSuccess = 'Setting updated successfully for fulfillment latency.';
          this.fulfillmentLatencyNumberSuccess = true;
          this.fulfillmentLatencyNumberMessage = '';
          setTimeout(() => {
            this.fulfillmentLatencyNumberSuccess = false;
            this.fulfillmentLatencyNumberSuccess = '';
          }, 5000);
        } else {
          console.error(response.data);
          this.fulfillmentLatencyNumberMessage = 'No such setting found';
        }
      })
      .catch(error => {
        console.error(error);
        this.fulfillmentLatencyNumberMessage = 'Failed to update fulfillment latency setting.  Refresh browser to see the value.';
      });
    },
    async fetchFulfillmentLatencyNumber() {
      try {
        const response = await axios.get('/admin-settings/get-admin-setting/fulfillment_latency');
        this.fulfillmentLatencyNumber = response.data.value;
      } catch (error) {
        console.error(error);
        this.fulfillmentLatencyNumberMessage = 'Failed to fetch initial value.';
      }
    },
    onChange(e) {
      this.message = '';
      this.success = false;
    },
    resetForm() {
      this.message = '';
      this.success = false;
    },
    formSubmit(e) {
      e.preventDefault();
      this.resetForm();
      let existingObj = this;
      axios.post('/backend-ui/start-sync')
          .then(function (res) {
            existingObj.success = true;
          })
          .catch(function (err) {
            existingObj.message = 'Error when trying to start the sync.';
            existingObj.success = false;
            if (err?.message) {
              existingObj.message = err.message;
            }
            console.log(err);
          });
    }
  }
}
</script>
